import { UITypes } from "types"

import { ReferralStatusCell } from "components/table/columnComponents/ReferralStatusCell"

export const referralStatusOptions: UITypes.Option[] = [
  { value: "pending_approval", label: "In review" },
  { value: "submitted", label: "Submitted" },
  { value: "in_progress", label: "In progress" },
  { value: "installed", label: "Installed" },
]

export const referralsTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Customer",
    type: "sort-search",
    size: "middle",
    name: "homeowner_name",
  },
  {
    title: "Address",
    type: "sort-search",
    size: "middle",
    name: "property_address1",
  },
  {
    title: "City",
    type: "default",
    size: "small",
    name: "city",
  },
  {
    title: "State",
    type: "default",
    size: "small",
    name: "state",
  },
  {
    title: "Customer Phone",
    type: "sort-search",
    name: "homeowner_phone",
  },
  {
    title: "Customer Email",
    type: "sort-search",
    name: "homeowner_email",
  },
  {
    title: "Creation date",
    type: "sort",
    name: "created_at",
  },
  {
    title: "Installer",
    type: "sort",
    size: "middle",
    name: "contractor_name",
  },
  {
    title: "Status",
    type: "select",
    name: "status",
    size: "middle",
    options: referralStatusOptions,
    cellComponent: ReferralStatusCell,
  },
]

export const getReferralsTableHeaderCells = (showArchive: boolean): UITypes.TableHeaderCell[] =>
  showArchive
    ? referralsTableHeaderCells.map(cell =>
        cell.name === "status" ? { ...cell, type: "default", options: undefined } : cell,
      )
    : referralsTableHeaderCells
